export const LOAD_ALL_IMAGE_NOTIFICATIONS_REQUEST = "LOAD_ALL_IMAGE_NOTIFICATIONS_REQUEST";
export const LOAD_ALL_IMAGE_NOTIFICATIONS_SUCCESS = "LOAD_ALL_IMAGE_NOTIFICATIONS_SUCCESS";
export const LOAD_ALL_IMAGE_NOTIFICATIONS_FAIL = "LOAD_ALL_IMAGE_NOTIFICATIONS_FAIL";

export const IMAGE_NOTIFICATION_DETAIL_REQUEST = "IMAGE_NOTIFICATION_DETAIL_REQUEST";
export const IMAGE_NOTIFICATION_DETAIL_SUCCESS = "IMAGE_NOTIFICATION_DETAIL_SUCCESS";
export const IMAGE_NOTIFICATION_DETAIL_FAIL = "IMAGE_NOTIFICATION_DETAIL_FAIL";

export const ADD_IMAGE_NOTIFICATION_REQUEST = "ADD_IMAGE_NOTIFICATION_REQUEST";
export const ADD_IMAGE_NOTIFICATION_SUCCESS = "ADD_IMAGE_NOTIFICATION_SUCCESS";
export const ADD_IMAGE_NOTIFICATION_RESET = "ADD_IMAGE_NOTIFICATION_RESET";
export const ADD_IMAGE_NOTIFICATION_FAIL = "ADD_IMAGE_NOTIFICATION_FAIL";

export const UPDATE_IMAGE_NOTIFICATION_REQUEST = "UPDATE_IMAGE_NOTIFICATION_REQUEST";
export const UPDATE_IMAGE_NOTIFICATION_SUCCESS = "UPDATE_IMAGE_NOTIFICATION_SUCCESS";
export const UPDATE_IMAGE_NOTIFICATION_RESET = "UPDATE_IMAGE_NOTIFICATION_RESET";
export const UPDATE_IMAGE_NOTIFICATION_FAIL = "UPDATE_IMAGE_NOTIFICATION_FAIL";

export const DELETE_IMAGE_NOTIFICATION_REQUEST = "DELETE_IMAGE_NOTIFICATION_REQUEST";
export const DELETE_IMAGE_NOTIFICATION_SUCCESS = "DELETE_IMAGE_NOTIFICATION_SUCCESS";
export const DELETE_IMAGE_NOTIFICATION_FAIL = "DELETE_IMAGE_NOTIFICATION_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
